export default __webpack_public_path__ + "static/iot@2x-02d7f3a8d22ddee545a09241397ee52f.png";